import { TUniView, TViewName } from "../Interfaces/Apis/Common.api.interface";
import { UniviewService } from "../unity-ui-common/Classes/Uniview";
import { API_URL } from "./Config";

export class Uniview extends UniviewService {
  constructor(uniView: TUniView, viewName: TViewName) {
    super(uniView, viewName, API_URL);
  }
}
